import React from 'react';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { dateTimeFormat } from "../../../util/DateUtil";
import Button from '@mui/material/Button';
import parse from 'html-react-parser';
import { Grid } from '@mui/material';

const useStyles = makeStyles(theme => ({
    send: {
        marginTop: '40px',
        backgroundColor: '#4caf50',
    },
    closeIcon: {
        cursor: 'pointer'
    },
}));

export default function ComunicadoUsuarioForm({
    handleConfirmRead,
    comunicadoUsuario,
    setComunicadoUsuario
}) {
    const classes = useStyles();

    return (
        <Grid container spacing={3} direction='column'>
            {console.log(comunicadoUsuario)}
            <Grid>
                <CloseIcon
                    onClick={() => setComunicadoUsuario(null)}
                    className={classes.closeIcon} />
            </Grid>
            <Grid>
                <Typography variant="h4">
                    {comunicadoUsuario && comunicadoUsuario.comunicado ? comunicadoUsuario.comunicado.titulo : ''}
                </Typography>
            </Grid>
            {comunicadoUsuario.comunicado.comunicadoBanner ?
                <Grid>
                    <img style={{
                        maxHeight: '400px',
                    }} src={comunicadoUsuario.comunicado.comunicadoBanner.urlBanner} alt='' />
                </Grid> :
                ''
            }
            <Grid>
                <Typography >
                    Data Hora Envio: {dateTimeFormat(comunicadoUsuario.createdAt)}
                </Typography>
            </Grid>
            <Grid>
                {comunicadoUsuario.comunicado.descricao ? parse(comunicadoUsuario.comunicado.descricao) : ''}
            </Grid>
            <Grid>
                <Typography >
                    Aluno: {comunicadoUsuario.aluno ? comunicadoUsuario.aluno.nome : '--'}
                </Typography>
            </Grid>
            {comunicadoUsuario.comunicado.dataHoraPara &&
                <Grid>
                    <Typography>
                        Data Hora Para: {dateTimeFormat(comunicadoUsuario.comunicado.dataHoraPara)}
                    </Typography>
                </Grid>
            }
            <Grid>
                <Button
                    disabled={comunicadoUsuario.leituraConfirmada || !comunicadoUsuario.usuario}
                    onClick={handleConfirmRead}
                    variant="contained"
                    className={classes.send}>
                    Confirmar Leitura
                </Button>
            </Grid>
        </Grid>
    );
}